/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useMemo} from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
// actions
import { signOut } from  '../../../../state/thunks/session'
import { PRODUCT_ARTICLE_SENTIMENT_V2, PRODUCT_COMMENTING, PRODUCT_COMMENTING_V2, PRODUCT_TRENDING_NOW_V2 } from '../../../../state/thunks/account';
// material
import NavItem from './navitem/navitem';
import NavSubItem from './navsubitem/navsubitem';
// styles
import injectSheet from 'react-jss';
import styles from './nav_styles';
import { PRODUCT_ARTICLE_SENTIMENT, PRODUCT_REQUEST_PENDING, PRODUCT_TRENDING_NOW } from '../../../../state/thunks/engagement';
import { url } from '../../../../utils/urls';
import { DATA_MIGRATION_READY } from 'utils/consts/migration';
import {fetchSspManagerUrl,validateAdminPermissions} from "../../../../state/thunks/settings";
import {baseUrl, publisherAdsTxtUrl, sspManagerUrl} from "../../../../state/thunks/api/embedadmin";


/* ========== ~~~~~~~~~~ NAV ~~~~~~~~~~ ========== */
const NavBeta = injectSheet(styles)((props) => {
    const mocked = useSelector(state => state.session.mocked);
    const userEmail = useSelector(state => state.session.userEmail);
    const sidebarOpen = useSelector(state => state.app.sidebarOpen);
    const currentPage = useSelector(state => state.app.currentPage);
    const {autoLoginPubPortalV2, siteUUID} = useSelector(state => state.session);
    const isOkoAccount = useSelector((state) => state.account.isOkoAccount)
    const accountName = useSelector((state) => state.account.accountName)
    const isHomePage = currentPage === '/';
    const isLogoutDisabled = mocked || !autoLoginPubPortalV2;
    const isInsticatorUser = mocked || /@insticator.com\s*$/.test(userEmail)
    const { migrationStatus, sitesWithProductsV2 }  = useSelector(state => state.migrationStatus)

    const dispatch = useDispatch();

    const redirectToAdminPanel = async (url) => {
        window.open(url, '_blank');
    }

    const {
        account: {
            accountProducts: productAccess
        },
        engagement: {
            accountProducts,
            articleSentimentAccessRequest: {
                requestStatus,
            } = {},
            trendingNowAccessRequest,
        }
    } = useSelector((state) => state);

    const hasCommentingAccess = productAccess?.includes(PRODUCT_COMMENTING);

    const hasCommentingV2Access = productAccess?.includes(PRODUCT_COMMENTING_V2);

    const hasArticleSentimentAccess = useMemo(() =>
            accountProducts.includes(PRODUCT_ARTICLE_SENTIMENT)
        , [accountProducts]
    )

    const hasTrendingNowAccess = useMemo(() =>
            accountProducts.includes(PRODUCT_TRENDING_NOW)
        , [accountProducts]
    )

    const hasTrendingNowV2Access = useMemo(() =>
        productAccess.includes(PRODUCT_TRENDING_NOW_V2)
      , [productAccess]
    )

    const isPendingArticleSentimentAccess = useMemo(() =>
            requestStatus === PRODUCT_REQUEST_PENDING
        , [requestStatus]
    )

    const isPendingTrendingNowAccess = useMemo(() =>
            trendingNowAccessRequest.requestStatus === PRODUCT_REQUEST_PENDING
        , [trendingNowAccessRequest]
    )

    const hasArticleSentimentV2Access = useMemo(() =>
        productAccess.includes(PRODUCT_ARTICLE_SENTIMENT_V2)
      , [productAccess]
    )
    const hasLegacyProductAccess = !hasCommentingV2Access && hasCommentingAccess

    // Show versions of product menu depending if site has v2 or not
    const showV2Menu = sitesWithProductsV2.includes(siteUUID) && hasCommentingV2Access

    // const showV1Menu = !sitesWithProductsV2.includes(siteUUID) && hasCommentingAccess

    const showV1Menu = false

    return (
        <nav id="sidebar-nav" className={`${props.classes.nav} sidebarOpen-${sidebarOpen}`}>
            <NavItem icon={`briefcase`} text={`Overview`} route={`/dashboard/overview`} isActive={isHomePage} />
            <NavItem icon={`coins`} text={`Monetization`} route={`/dashboard/monetization`}>
                <NavSubItem text={`Engagement Products`} route={`/dashboard/monetization/engagementproducts`} />
                <NavSubItem text={`Full Ad Management`} route={`/dashboard/monetization/fulladmanagement`} />
                <NavSubItem text={`Mobile App`} route={`/dashboard/monetization/mobileapp`} disabled={true} />
                <NavSubItem text={`Video Ad Management`} route={`/dashboard/monetization/videoadmangement`} />
                <NavSubItem text={`Supply Side Platform`} route={`/dashboard/monetization/supplysideplatform`} />
                {(mocked || isOkoAccount) && <NavSubItem text={`Monetization Configuration`} route={`/dashboard/monetization/configuration`}/>}
            </NavItem>
            {/* Product manager should be hidden only if site has active commenting v1 */}
            <NavItem icon={`toggle-on`} text={`Product Manager`} route={`/dashboard/productmanager`}  />
            {/* 04.16.25 - https://insticatorinc.atlassian.net/browse/CMMT2-2583 */}
             {/* Deprecate 1.0 Product  */}
            {/* {(hasCommentingV2Access) &&
              <NavItem icon={`comment-alt`} text={`Commenting`} route={`/dashboard/commenting`} disabled={false}>
                <NavSubItem text={`Analytics`} route={`/dashboard/commenting/analytics`} disabled={false} />
                {showV1Menu && <NavSubItem text={`Get Code`} route={`/dashboard/commenting/code`} disabled={!hasCommentingAccess} />}
                { showV1Menu ?
                    <NavSubItem text={`Configuration`} route={`/dashboard/commenting/configuration`} disabled={!hasCommentingAccess}/>
                    :
                    showV2Menu ?
                      <NavSubItem text={`Configuration`} route={`/dashboard/commenting/configuration`} disabled={!hasCommentingV2Access} isNew={migrationStatus === DATA_MIGRATION_READY} />
                      :
                      <NavSubItem text={`Configuration`} route={`/dashboard/commenting/requestaccess`} />
                }
                {showV1Menu && <NavSubItem text={`Advanced`} route={`/dashboard/commenting/advanced`} disabled={!hasCommentingAccess} />}
                {showV2Menu && <NavSubItem text={`Moderation`} route={`/dashboard/moderation/config`} disabled={!(hasCommentingV2Access && isInsticatorUser)} />            }
                {isInsticatorUser && showV2Menu && <NavSubItem text={`Import Data`} route={`/dashboard/commenting/importertool`} disabled={!hasCommentingAccess && !hasCommentingV2Access} />}
            </NavItem>
            } */}
            {(hasCommentingV2Access) &&
              <NavItem icon={`comment-alt`} text={`Commenting`} route={`/dashboard/commenting`} disabled={false}>
                <NavSubItem text={`Analytics`} route={`/dashboard/commenting/analytics`} disabled={false} />
                <NavSubItem text={`Configuration`} route={`/dashboard/commenting/configuration`} disabled={!hasCommentingV2Access} isNew={migrationStatus === DATA_MIGRATION_READY} />
                <NavSubItem text={`Moderation`} route={`/dashboard/moderation/config`} disabled={!(hasCommentingV2Access && isInsticatorUser)} />
                {isInsticatorUser && <NavSubItem text={`Import Data`} route={`/dashboard/commenting/importertool`} disabled={!hasCommentingAccess && !hasCommentingV2Access} />}
            </NavItem>
            }
            {showV1Menu && <NavItem icon={`glasses`} text={`Moderation`} externalLink={url.comment.moderation.url} disabled={!(hasCommentingAccess && isInsticatorUser)} />}            
            {(hasArticleSentimentV2Access) &&
              <NavItem icon={`smile`} text={`Article Sentiment`} route={`/dashboard/articlesentiment`} disabled={false}>
                <NavSubItem text={`Analytics`} route={`/dashboard/articlesentiment/analytics`} />
                <NavSubItem text={`Configuration`} route={`/dashboard/articlesentiment/configuration`} />
              </NavItem>
            }
            {(hasTrendingNowV2Access) &&
              <NavItem icon={`bolt`} text={`Trending Now`} route={`/dashboard/trendingnow`} disabled={false}>
                <NavSubItem text={`Analytics`} route={`/dashboard/trendingnow/analytics`} />
                <NavSubItem text={`Configuration`} route={`/dashboard/trendingnow/configuration`} />
              </NavItem>
            }
            <NavItem icon={`poll-h`} text={`Trivia & Polls`} route={`/dashboard/triviapolls`} disabled={false}>
                <NavSubItem text={`Analytics`} route={`/dashboard/triviapolls/analytics`} disabled={false} />
                <NavSubItem text={`Configuration`} route={`/dashboard/triviapolls/configuration`} />
            </NavItem>
            {showV1Menu && 
            <NavItem icon={`puzzle-piece`} text={`Trends & Reactions`} route={`/dashboard/trendsandreactions`} disabled={isPendingArticleSentimentAccess && isPendingTrendingNowAccess}>
                <NavSubItem text={`Analytics`} route={`/dashboard/trendsandreactions/analytics`} disabled={true} />
                <NavSubItem text={`Get Code`} route={`/dashboard/trendsandreactions/getcode`} disabled={!(hasArticleSentimentAccess || hasTrendingNowAccess)} />
                <NavSubItem text={`Configuration`} route={`/dashboard/trendsandreactions/configuration`} disabled={isPendingArticleSentimentAccess && isPendingTrendingNowAccess}/>
                <NavSubItem text={`Advanced`} route={`/dashboard/trendsandreactions/advanced`} disabled={!(mocked && hasArticleSentimentAccess)} />
            </NavItem>
            }
            <NavItem icon={`chart-pie`} text={`Report Builder`} route={`/dashboard/reportbuilder`} />
            <NavItem icon={'question-circle'} text={'Help Center'} externalLink={'https://documentation.insticator.com/docs'}/>
            <NavItem icon={`cog`} text={'Settings'} route={'/dashboard/settings'}>
                <NavSubItem text={'My Account'} route={'/dashboard/settings/account'} />
                <NavSubItem text={'Users'} route={'/dashboard/settings/users'} />
                <NavSubItem text={'Billing'} route={'/dashboard/settings/billing'} />
                {mocked && <NavSubItem text={'Company'} route={'/dashboard/settings/company'} />}
                <NavSubItem text={'Developer Tools'} route={'/dashboard/settings/developerTools'} />
                {mocked && <NavSubItem text={'COOL Media Platform'} route={'/dashboard/settings/insticatorplatform'}/>}
                <NavSubItem text={'Logout'} handleOnClick={() => dispatch(signOut())} disabled={isLogoutDisabled} />
            </NavItem>
            {mocked &&
                <NavItem icon={`building`} text={'Global Settings'} route={'/dashboard/globalsettings'}>
                    <NavSubItem text={'MCM'} route={'/dashboard/globalsettings/mcm'} disabled={!mocked} />
                    <NavSubItem text={'Ad Serve Blocking'} route={'/dashboard/globalsettings/adServeBlocking'} disabled={!mocked}/>
                    <NavSubItem text={'SSP Manager'} handleRouteClick={() =>  redirectToAdminPanel(sspManagerUrl)} disabled={!mocked} />
                    <NavSubItem text={'Publisher Ads.txt Files'} handleRouteClick={() => redirectToAdminPanel(`${publisherAdsTxtUrl}?accountName=${accountName}`)} disabled={!mocked} />
                </NavItem>
            }
        </nav>
    );
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NavBeta;
